import { AppUtils } from '../../../../../shared/utils/index';

export class AppFormModel {
	constructor(initialProperties?: Partial<AppFormModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	private delivery: string;
	set Delivery(value: string) {
		this.delivery = value;
	}

	get Delivery(): string {
		return this.delivery;
	}


	private email?: string;
	set Email(value: string | undefined) {
		this.email = value;
	}

	get Email(): string | undefined {
		return this.email;
	}

	private submissionDate: string;
	set SubmissionDate(value: string) {
		this.submissionDate = value;
	}

	get SubmissionDate(): string {
		return this.submissionDate;
	}

	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel);
	}
}